// Card-to-product page animation. When a visitor clicks a link to a product, the photo in that card gets the
// shared "product-hero" name, so the page transition grows it into the product page gallery (named the same).
// Browsers without cross-page transitions simply navigate as usual.
const HERO = 'product-hero';

const clearHeroes = () => {
  document.querySelectorAll('[data-vt-hero]').forEach((el) => {
    el.style.viewTransitionName = '';
    el.removeAttribute('data-vt-hero');
  });
};

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest?.('a[href*="/products/"]');
  if (!link || link.target === '_blank' || link.origin !== window.location.origin) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const card = link.closest('li, article, [data-product-card]') || link;
  const image = card.querySelector('img');
  if (!image || image.getBoundingClientRect().width === 0) return;

  // Only one element per page may carry the name: release the current page's gallery and any earlier pick.
  clearHeroes();
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery && !gallery.contains(image)) gallery.style.viewTransitionName = 'none';

  image.style.viewTransitionName = HERO;
  image.setAttribute('data-vt-hero', '');
});

// Coming back (including from the back/forward cache): reset names so the next click starts clean.
window.addEventListener('pageshow', () => {
  clearHeroes();
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) gallery.style.viewTransitionName = HERO;
});
